import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-[#2e475d] text-white",
        secondary: "border-[#cbd6e2] bg-[#eaf0f6] text-[#33475b]",
        destructive: "border-transparent bg-[#fce4e4] text-[#d94c53]",
        outline: "text-foreground border-border",
        success: "border-transparent bg-[#e5f5ee] text-[#00856a]",
        warning: "border-transparent bg-[#fef3e0] text-[#b8600b]",
        info: "border-transparent bg-[#e0f3fa] text-[#0091ae]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
